module.exports = __webpack_public_path__ + "img/vipyrb@2x.7a3d79b6.png";